import React, { useState } from "react";
import { LAYOUT_CONSTANTS } from "@/_self_managed/LAYOUT_CONSTANTS";
import {
  icons,
  colors2,
  UI_CAPTION,
  UI_CAPTION_BOLD_DF,
  UI_CAPTION_DF,
  ButtonPrimaryCompact,
} from "oolib";
import { SM_UIContent } from "@/_self_managed/SM_UIContent";
const { Sparkle } = icons;
export const DirectImport_AICat_ComsBox = () => {

    const [show,setShow] = useState(localStorage.getItem("COMS_BOX_DirectImport_AICat") !== "seen")

if(!show) return null;
  return (
    <div
      style={{
        padding: LAYOUT_CONSTANTS.topBottomPadding + "px",
        background: colors2.purple8,
        borderRadius: "6px",
      }}
    >
      <UI_CAPTION_BOLD_DF style={{ color: colors2.purple }}>
        {SM_UIContent.DirectDataImport_AICat_ComsBox.title}
      </UI_CAPTION_BOLD_DF>
      <div style={{ color: colors2.purple, paddingTop: "6px" }}>
        <UI_CAPTION_DF style={{ display: "inline" }}>{SM_UIContent.DirectDataImport_AICat_ComsBox.span1}</UI_CAPTION_DF>{" "}
        <div
          style={{
            width: "18px",
            height: "18px",
            borderRadius: "6px",
            background: colors2.purple,
            display: "inline-flex",
            verticalAlign: "bottom",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Sparkle size={15} color={colors2.white} />
        </div>{" "}
        <UI_CAPTION_DF style={{ display: "inline" }}>
          {SM_UIContent.DirectDataImport_AICat_ComsBox.span2}
        </UI_CAPTION_DF>
      </div>
      <UI_CAPTION_DF style={{ color: colors2.purple, paddingTop: "6px" }}>
          {SM_UIContent.DirectDataImport_AICat_ComsBox.span3}
        </UI_CAPTION_DF>
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
      <ButtonPrimaryCompact
        style={{
          marginTop: "4px",
          background: colors2.purple,
          color: colors2.white,

        }}
        onClick={() => {
          localStorage.setItem("COMS_BOX_DirectImport_AICat", "seen");
          setShow(false)
        }}
      >
        Got it
      </ButtonPrimaryCompact>
      </div>
    </div>
  );
};
